/**
 * Écran affiché quand un référent avec statut "Complété" tente d'accéder au formulaire
 */

import { CheckCircle } from 'lucide-react';
import { BrandingSettings } from '@/hooks/useReferentBranding';

interface AlreadySubmittedStepProps {
  candidateName?: string;
  branding?: BrandingSettings | null;
}

export const AlreadySubmittedStep = ({ candidateName, branding }: AlreadySubmittedStepProps) => {
  const primaryColor = (branding?.enabled && branding?.primaryColor) ? branding.primaryColor : '#4ECDC4';
  return (
    <div className="min-h-screen bg-gray-50 py-8 font-['Bricolage_Grotesque']">
      <div className="max-w-2xl mx-auto px-4">
        {/* En-tête avec logo */}
        <div className="flex justify-center mb-8">
          <img
            src={(branding?.enabled && branding?.logoUrl) ? branding.logoUrl : "/lovable-uploads/c941c7a1-d271-4c8b-91a4-2611677da8a6.png"}
            alt={(branding?.enabled && branding?.logoUrl) ? "Logo Entreprise" : "Getproof Logo"}
            className="h-12"
          />
        </div>

        {/* Contenu principal */}
        <div className="bg-white rounded-lg shadow-sm p-8 text-center">
          {/* Icône de succès */}
          <div className="flex justify-center mb-6">
            <div 
              className="w-16 h-16 rounded-full flex items-center justify-center"
              style={{ backgroundColor: `${primaryColor}20` }}
            >
              <CheckCircle 
                className="w-8 h-8" 
                style={{ color: primaryColor }}
              />
            </div>
          </div>

          {/* Titre */}
          <h1 className="text-2xl font-medium font-['Bricolage_Grotesque'] text-gray-800 mb-4">
            Évaluation déjà soumise
          </h1>

          {/* Message */}
          <div className="space-y-4 text-gray-600">
            <p className="text-lg">
              Vous avez déjà soumis votre évaluation pour {candidateName ? `le candidat ${candidateName}` : 'ce candidat'}.
            </p>
            
            <p>
              Votre réponse a été enregistrée avec succès et transmise au recruteur.
            </p>

            <p className="text-sm text-gray-500">
              Pour des raisons de confidentialité et d'intégrité, les évaluations finalisées ne peuvent plus être modifiées.
            </p>
          </div>

          {/* Message de remerciement */}
          <div 
            className="mt-8 p-4 rounded-lg"
            style={{ backgroundColor: `${primaryColor}10` }}
          >
            <p 
              className="font-medium"
              style={{ color: primaryColor }}
            >
              Merci pour votre participation !
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};